import { render, staticRenderFns } from "./provider-allevents.vue?vue&type=template&id=90680538&scoped=true"
import script from "./provider-allevents.vue?vue&type=script&lang=js"
export * from "./provider-allevents.vue?vue&type=script&lang=js"
import style0 from "./provider-allevents.vue?vue&type=style&index=0&id=90680538&prod&lang=css"
import style1 from "./provider-allevents.vue?vue&type=style&index=1&id=90680538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90680538",
  null
  
)

export default component.exports